/**
 * Wrapper class for our animations, initiates a class for each of them
 * 
 * @export
 * @class
 */
import * as Rellax from 'rellax';

import { createNewEvent, getAll } from '../helpers/utilities';

import { FadeIn } from './fade-in';
import { FadeSlideUp } from './fade-slide-up';

interface Constructable<T> {
    new(container: Element) : T;
}

interface AnimationInitializer {
    selector: string,
    class: Constructable<any>;
}

export class Animations {


    /**
     * Array containing our block data, takes a selector and a class.
     */
    private blocks: AnimationInitializer[] = [
        {
            selector: '.js-fade-slide-up',
            class: FadeSlideUp
        },
        {
            selector: '.js-fade-in',
            class: FadeIn
        }
    ];

    /**
     * Loops through our blocks and initiates a class for each
     * 
     * @memberof Animations
     */
    constructor() {
        this.initiateBlocks();

        // Rellax
        new Rellax('.js-rellax', {
            round: true,
            center: true,
        });
        setTimeout(() => {
            window.dispatchEvent(createNewEvent('resize'));
        });
    }


    /**
     * Initiate our animation blocks
     */
    private initiateBlocks(): void {
        if(!this.blocks) return;

        this.blocks.forEach(blockGroup => {
            const blocks = getAll(blockGroup.selector);
            if(blocks) {
                blocks.forEach((block: Element) => {
                    new blockGroup.class(block);
                });
            }
        });
    }
}
